import { type AfterViewInit, Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: "404.component.html",
    standalone: false,
})
export class P404Component implements AfterViewInit {
    private modalService = inject(NgbModal);
    private activatedRoute = inject(ActivatedRoute);

    errorType: string;

    constructor() {
        this.errorType = this.activatedRoute.snapshot.params["error-type"];
    }

    ngAfterViewInit() {
        this.modalService.dismissAll();
    }
}
